"use client"

import { LinkButton } from "@/components/LinkButton"
import { Modal } from "@/components/ui/Modal"
import Image from "next/image"
import { useRouter, useSearchParams } from "next/navigation"

export function RenewSuccess() {
  const params = useSearchParams()
  const router = useRouter()
  const renewSucess = params?.get("renew-success") as string | undefined
  return (
    <Modal isOpen={!!renewSucess} onClose={() => router.push("/")} size="xl">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="space-y-6 py-4">
          <div>
            <h1 className="text-4xl">Payment succeeded</h1>
            <p className="text-xl">Your plan has been renewed!</p>
          </div>
          <Image
            width={380}
            height={300}
            className="w-full max-w-[380px] object-cover"
            src="/payment-succeeded.png"
            alt="success"
          />
          <LinkButton href="/" variant="primary">
            Explore TrendWatching
          </LinkButton>
        </div>
      </div>
    </Modal>
  )
}

export function UpgradeSuccess() {
  const params = useSearchParams()
  const router = useRouter()
  const upgradeSucess = params?.get("upgrade-success") as string | undefined
  return (
    <Modal isOpen={!!upgradeSucess} onClose={() => router.push("/")} size="xl">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="space-y-6 py-4">
          <div>
            <h1 className="text-4xl">Payment succeeded</h1>
            <p className="text-xl">You now have a full membership!</p>
          </div>
          <Image
            width={380}
            height={300}
            className="w-full max-w-[380px] object-cover"
            src="/payment-succeeded.png"
            alt="success"
          />
          <LinkButton href="/" variant="primary">
            Dive back in
          </LinkButton>
        </div>
      </div>
    </Modal>
  )
}
